import enMessages from '../locales/en/messages.json';
import zhMessages from '../locales/zh/messages.json';
import enCitizenship from '../locales/en/citizenship.json';
import zhCitizenship from '../locales/zh/citizenship.json';
import enResidency from '../locales/en/residency.json';
import zhResidency from '../locales/zh/residency.json';
import enProjects from '../locales/en/projects.json';
import zhProjects from '../locales/zh/projects.json';

type Locale = 'en' | 'zh';
type Messages = { [key: string]: string };
type NestedMessages = {
  [key: string]: string | NestedMessages | (string | NestedMessages)[];
};

// Flatten messages object while preserving namespaces
const flattenMessages = (nestedMessages: NestedMessages, prefix = ''): Messages => {
  return Object.keys(nestedMessages).reduce((messages: Messages, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else if (Array.isArray(value)) {
      // Handle arrays by converting them to indexed objects
      value.forEach((item, index) => {
        if (typeof item === 'string') {
          messages[`${prefixedKey}.${index}`] = item;
        } else if (typeof item === 'object' && item !== null) {
          Object.assign(messages, flattenMessages(item as NestedMessages, `${prefixedKey}.${index}`));
        }
      });
    } else if (typeof value === 'object' && value !== null) {
      Object.assign(messages, flattenMessages(value as NestedMessages, prefixedKey));
    }

    return messages;
  }, {});
};

// Merge messages, citizenship, residency, and projects translations
const messages: Record<Locale, Messages> = {
  en: {
    ...flattenMessages(enMessages),
    ...flattenMessages(enCitizenship),
    ...flattenMessages({ residency: enResidency }),
    ...flattenMessages({ projects: enProjects }),
  },
  zh: {
    ...flattenMessages(zhMessages),
    ...flattenMessages(zhCitizenship),
    ...flattenMessages({ residency: zhResidency }),
    ...flattenMessages({ projects: zhProjects }),
  },
};

export default messages; 